<template>
  <div />
</template>

<script>
/**
 * Legacy URL: /tournaments/:id/bracket/:bracketId/overall-ranking
 * General ranking is shown on the main bracket page; redirect preserves bookmarks.
 */
export default {
  name: 'TournamentOverallRanking',

  created () {
    const id = this.$route.params.id
    const bracketId = this.$route.params.bracketId
    this.$router.replace({
      name: 'TournamentBracket',
      params: { id },
      query: { overall: String(bracketId) }
    })
  }
}
</script>
